import { useState } from "react";
import { List, Card, Space, Typography, Button } from "antd";
import { DeleteOutlined, FileTextOutlined } from "@ant-design/icons";
import "./DokumentCardsKorisnik.css";
import "./DokumentCards.css";
import { formatDateTime } from "../../utils/formatDateTime";

const { Text } = Typography;

const handleOpenPdf = async (dokument) => {
  if (!dokument.putanja) return;

  const filename = dokument.putanja.split("/").pop();
  const url = `/dokument/preview/${filename}`;

  const isPdf = filename.toLowerCase().endsWith(".pdf");

  if (isPdf) {
    window.open(url, "_blank");
  } else {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      }, 100);
    } catch (error) {
    }
  }
};

function DokumentCards({ dokumenti, onDeleteClick }) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentDokumenti = dokumenti.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(dokumenti.length / itemsPerPage);
  return (
    <List
      grid={{ gutter: 16, xs: 1, sm: 1, md: 3, lg: 4, xl: 4, xxl: 4 }}
      dataSource={currentDokumenti}
      locale={{ emptyText: "Nema dostupnih dokumenata." }}
      renderItem={(dokument, index) => {
        const colors = ["#c9bc8d", "#f7eba8", "#babd7d", "#ded6a0"];
        const backgroundColor = colors[index % colors.length];

        return (
          <List.Item>
            <div className="document-cards-zaposleni">
              <Card
                hoverable
                onClick={() => handleOpenPdf(dokument)}
                cover={
                  <div
                    className="dokument-card-cover"
                    style={{ backgroundColor }}
                  >
                    <FileTextOutlined
                      style={{ fontSize: 48, color: "#2b494b" }}
                    />
                  </div>
                }
              >
                <div className="dokument-card-title">{dokument.naziv}</div>
                <Space
                  className="document-card-footer-zaposleni"
                  align="center"
                  size={0}
                >
                  <Text type="secondary" className="dokument-card-autor">
                    {dokument.autor}
                  </Text>
                  <Text type="secondary">
                    <span>({dokument.putanja.split(".").pop()}) </span>
                    {formatDateTime(dokument.datumDodavanja)}
                  </Text>
                  <Button
                    key="delete"
                    icon={<DeleteOutlined />}
                    onClick={(e) => {
                      e.stopPropagation();
                      onDeleteClick(dokument.id);
                    }}
                    className="card-action-button"
                    type="text"
                  />
                </Space>
              </Card>
            </div>
          </List.Item>
        );
      }}
    >
      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            {" "}
            Prethodna{" "}
          </button>
          <span>
            Stranica {currentPage} od {totalPages}
          </span>
          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            {" "}
            Sljedeća
          </button>
        </div>
      )}
    </List>
  );
}
export default DokumentCards;
